import React from 'react';

import pic from '../../assets/images/pic.jpg'

import "./style.scss"
const AboutImage = () => {
  return (
    <div className='about_profile'>
      <img
        src={pic}
        alt='pic'
      />
    </div>
  );
};

export default AboutImage;
